import { configureStore } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { apiSlice } from './api/apiSlice';
import userReducer from '@/features/user/userSlice.ts';
import { counterReducer } from '@/features/counterSlice.ts';
import { userPreferencesApi } from '@/services/userPreferencesService.tsx';
import updateReducer from '@/services/updateService.ts';
import errorReducer from '@/services/errorHandlingService';


// Get persisted preferences from localStorage
const persistedPreferences = JSON.parse(localStorage.getItem('userPreferences') || '{}');

// Configure the Redux store
const store = configureStore({
  reducer: {
    [apiSlice.reducerPath]: apiSlice.reducer,
    [userPreferencesApi.reducerPath]: userPreferencesApi.reducer,
    counter: counterReducer,
    user: userReducer,
    update: updateReducer,
    error: errorReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(apiSlice.middleware)
      .concat(userPreferencesApi.middleware),
});

// Define types for RootState and AppDispatch
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Define hooks
export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export default store;